exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-modal-preview .modal-body {\n  padding: 0;\n}\n.fm-modal-preview .modal-body img {\n  max-width: 100%;\n}\n.fm-modal-preview > .d-flex {\n  padding: 1rem;\n  border-top: 1px solid #e9ecef;\n}", ""]);

// exports
